module.exports = __webpack_public_path__ + "./fonts/DMSans-Bold.b316fb.woff2";